import { PromptSidebarContent } from "@/components/flow/build/Steps/Prompt/SidebarContent/PromptSidebarContent";
import { ReviewSidebarContent } from "@/components/flow/build/Steps/Review/SidebarContent";
import { PromptVisualAreaContent } from "@/components/flow/build/Steps/Prompt/VisualAreaContent";
import { ReviewVisualAreaContent } from "@/components/flow/build/Steps/Review/VisualAreaContent";
import { UploadVisualAreaContent } from "@/components/flow/build/Steps/Upload/VisualAreaContent";
import { PromptVisualAreaBottomContent } from "@/components/flow/build/Steps/Prompt/VisualAreaBottomContent";
import { PreviewSidebarContent } from "@/components/flow/build/Steps/Preview/SidebarContent";
import { PreviewVisualAreaContent } from "@/components/flow/build/Steps/Preview/VisualAreaContent";
import { BuildLayout } from "@/components/flow/build/Layout";
import { BuildSteps } from "@/types/flows";
import { useFlowState } from "@/hooks/useFlowState";

export const BuildPage = () => {
    const { step } = useFlowState();

    switch (step) {
        case BuildSteps.UPLOAD:
            return <UploadVisualAreaContent />;
        case BuildSteps.PROMPT:
            return (
                <BuildLayout
                    Sidebar={<PromptSidebarContent />}
                    VisualArea={<PromptVisualAreaContent />}
                    BottomContent={<PromptVisualAreaBottomContent />}
                />
            );
        case BuildSteps.REVIEW:
            return (
                <BuildLayout
                    Sidebar={<ReviewSidebarContent />}
                    VisualArea={<ReviewVisualAreaContent />}
                    // BottomContent={<ReviewVisualAreaBottomContent />}
                />
            );
        case BuildSteps.PREVIEW:
            return (
                <BuildLayout
                    Sidebar={<PreviewSidebarContent />}
                    VisualArea={<PreviewVisualAreaContent />}
                    // BottomContent={<PreviewVisualAreaBottomContent />}
                />
            );
        default:
            throw new Error(`Invalid step: ${step}`);
    }
};
